import { getIdFromPath, getItemIdFromPath } from '@/utils/urls';
import { sailthruTrack } from './utils//sailthru';
import { trackPageView } from '@/redux/modules/analytics/analytics.actions';
import { useAppDispatch } from '@/redux/hooks';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TRACKING_DELAY_MS = 1500;

export const PageTracker = () => {
    const dispatch = useAppDispatch();
    const { pathname, search } = useLocation();

    const itemId = getItemIdFromPath(pathname) || 0;
    const catalogId = !Boolean(itemId) ? getIdFromPath(pathname) : 0;

    useEffect(() => {
        const pageViewTimeout = setTimeout(() => {
            dispatch(trackPageView({ catalogId, itemId }));
            sailthruTrack(pathname);
        }, TRACKING_DELAY_MS);

        return () => clearTimeout(pageViewTimeout);
    }, [catalogId, dispatch, itemId, pathname, search]);

    return null;
};
